module.exports = __webpack_public_path__ + "assets/img/icon_share.c15fb2a7.svg";